import React from 'react'
import { observer } from 'mobx-react'

import BookkeepingManagerDetailsViewModel from './BookkeepingManagerDetailsViewModel'
import DetailsHeader from './DetailsHeader'
import DetailsContent from './DetailsContent'
import ProviderSection from './ProviderSection'
import DetailsFooter from './DetailsFooter'

import styles from './BookkeepingManagerDetails.sass'
import AssessmentSection from './AssessmentSection'
import { BookkeepingManagerAction } from 'admin/bookkeeping/BookkeepingPendingAction'
import UpdateJobScopeDialog from 'jobs/views/JobRoot/Job/UpdateJobScopeDialog'
import RequestScopeChangesDialog from 'jobs/views/JobRoot/Job/RequestScopeChangesDialog'
import Member from 'iam/models/Member'

interface BookkeepingManagerDetailsProps {
  vm: BookkeepingManagerDetailsViewModel
}

export default observer(function BookkeepingManagerDetails({
  vm,
}: BookkeepingManagerDetailsProps) {
  if (!vm.showing) {
    return null
  }

  return (
    <div className={styles.root}>
      <DetailsHeader onClose={vm.close} />
      <DetailsContent vm={vm} />
      {vm.bookkeepingPendingAction.championPro !== Member.none && (
        <ProviderSection vm={vm.bookkeepingPendingAction} />
      )}
      {vm.bookkeepingPendingAction.action ===
        BookkeepingManagerAction.AssessmentReview && (
        <AssessmentSection vm={vm} />
      )}
      <DetailsFooter vm={vm} />

      {vm.updateJobScopeVM && <UpdateJobScopeDialog vm={vm.updateJobScopeVM} />}
      {vm.requestScopeChangesVM && (
        <RequestScopeChangesDialog vm={vm.requestScopeChangesVM} />
      )}
    </div>
  )
})
